import { useEffect } from 'react'
import { useBucket, useExperimentVariables } from '@mc/experiments-react'
import { usePlansContext } from '@mc/plans-ui'
import { COLLAPSED_PAINTED_DOOR_FLAG_NAME } from '../constants'
import { trackCollapsedPaintedDoorViewed } from '../events/trackCollapsedPaintedDoorViewed'

export const useExperiment = ({ track }: { track?: boolean } = {}) => {
  const variant = useBucket(COLLAPSED_PAINTED_DOOR_FLAG_NAME)
  const { giftEnabled } = useExperimentVariables<{ giftEnabled?: boolean }>(
    COLLAPSED_PAINTED_DOOR_FLAG_NAME,
  )
  const { isGift } = usePlansContext()
  const giftFlowAllowed = giftEnabled || !isGift

  useEffect(() => {
    if (track) {
      trackCollapsedPaintedDoorViewed()
    }
  }, [track])

  return {
    isOn:
      (variant === 'control' || variant?.startsWith('variant')) &&
      giftFlowAllowed,
    isVariant: variant?.startsWith('variant') && giftFlowAllowed,
    variant,
  }
}
